import { ResourcesConfig } from 'aws-amplify'

const cognitoUserPoolId = import.meta.env.PROD
  ? import.meta.env.VITE_APP_PROD_COGNITO_USER_POOL_ID
  : import.meta.env.VITE_APP_DEV_COGNITO_USER_POOL_ID

const cognitoClientId = import.meta.env.PROD
  ? import.meta.env.VITE_APP_PROD_COGNITO_CLIENT_ID
  : import.meta.env.VITE_APP_DEV_COGNITO_CLIENT_ID

export const cognitoConfig = {
  userPoolId: cognitoUserPoolId,
  clientId: cognitoClientId
}

export const appSyncConfig: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: import.meta.env?.VITE_APP_APP_SYNC_ENDPOINT,
      region: import.meta.env?.VITE_APP_APP_SYNC_REGION ?? 'eu-north-1',
      defaultAuthMode: import.meta.env?.VITE_APP_APP_SYNC_DEFAULT_AUTH_MODE ?? 'userPool'
    }
  },
  Auth: {
    Cognito: {
      userPoolId: cognitoUserPoolId,
      userPoolClientId: cognitoClientId,
      identityPoolId: import.meta.env?.VITE_APP_COGNITO_ID
    }
  }
}
